import React from 'react';
import { Table, Avatar, Badge, Button } from '@/components/ui';
import type { ConstructionProgressLog } from '../types/construction-progress.types';
import { ProgressStatusBadge } from './ProgressStatusBadge';

interface Props {
  data: ConstructionProgressLog[];
  isLoading?: boolean;
  onViewDetail: (id: string) => void;
}

export const ProgressTable: React.FC<Props> = ({ data, isLoading, onViewDetail }) => {
  return (
    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden">
      <Table
        columns={[
          { key: 'log_date', title: 'Ngày ghi nhận', width: '150px' },
          { key: 'reporter', title: 'Người báo cáo' },
          { key: 'team', title: 'Tổ đội / Khu vực' },
          { key: 'summary', title: 'Nội dung tóm tắt' },
          { key: 'quantity', title: 'Sản lượng', align: 'right' },
          { key: 'status', title: 'Trạng thái', width: '120px' },
          { key: 'actions', title: '', width: '80px' },
        ]}
        data={data}
        isLoading={isLoading}
        renderCell={(row, key) => {
          switch (key) {
            case 'log_date':
              return <span className="text-sm font-bold text-slate-700">{new Date(row.log_date).toLocaleDateString('vi-VN')}</span>;
            case 'reporter':
              return (
                <div className="flex items-center gap-2">
                  <Avatar src={row.reporter?.avatar_url} fallback={row.reporter?.full_name?.substring(0, 2)} size="xs" />
                  <span className="text-xs font-medium text-slate-600">{row.reporter?.full_name}</span>
                </div>
              );
            case 'team':
              return (
                <div className="flex flex-col">
                  <span className="text-xs font-bold text-slate-700">{row.team?.name || '---'}</span>
                  <span className="text-[10px] text-os-primary">{row.zone?.zone_name || 'Văn phòng'}</span>
                </div>
              );
            case 'summary':
              return <span className="text-xs text-slate-500 line-clamp-1">{row.summary || '---'}</span>;
            case 'quantity':
              return (
                <div className="flex flex-col items-end">
                  <span className="text-sm font-bold text-os-primary">{row.completed_quantity} {row.unit}</span>
                  <span className="text-[10px] text-slate-400">{row.progress_percent}% hoàn thành</span>
                </div>
              );
            case 'status':
              return <ProgressStatusBadge status={row.status_code} />;
            case 'actions':
              return (
                <Button 
                  variant="ghost" 
                  size="sm" 
                  icon="ri-arrow-right-line" 
                  onClick={() => onViewDetail(row.id)}
                />
              );
            default: return null;
          }
        }}
      />
    </div>
  );
};
